import { atom } from 'jotai';
export const $Crawler = atom({});
//# sourceMappingURL=crawler.js.map